<script>
  // @ts-nocheck
  import { Pane } from 'svelte-splitpanes';

  export let index = 0;
  export let paneSizes = [];

  $: config = paneSizes?.[index] || {};

  // Chuẩn hóa để tránh layout jump
  $: size = Number.isFinite(config?.size) ? config.size : undefined;
  $: min = Number.isFinite(config?.min) ? config.min : undefined;
  $: max = Number.isFinite(config?.max) ? config.max : undefined;
  $: snap = config?.snap ?? false;
  $: snapSize = Number.isFinite(config?.snapSize) ? config.snapSize : undefined;

  // Quan trọng: ZenSplit đã ép locked nếu mode=fixed
  $: locked = config?.locked ?? false;
  $: collapsible = config?.collapsible ?? false;
</script>

<Pane {size} {min} {max} {snap} {snapSize} {locked} {collapsible} {...$$restProps}>
  <slot />
</Pane>
